import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';

@Component({
  selector: 'app-insurancereport',
  templateUrl: './insurancereport.component.html',
  styleUrls: ['./insurancereport.component.css']
})
export class InsurancereportComponent implements OnInit {

  @ViewChild('filterbar',{static:false}) filterbar;

  isadd:boolean=false;
  isedit:boolean=false;
  isdelete:boolean=false;
  isview:boolean=false;
  isprint:boolean=false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "InsuranceReport";

  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = "ALL"; 
  dtOptions: DataTables.Settings = {};
    
 insuranceColl:any=[];
 

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Employee Name', field: 'empname' },     
    { headerName: 'Invoice Type Name', field: 'insurancetypename' },     
    { headerName: 'Insurance Company Name', field: 'insurancecompanyname' },
    { headerName: 'Start On', field: 'startdt',type:'date'},
    { headerName: 'End On', field: 'enddt' ,type:'date'},
    { headerName: 'Description', field: 'descr' },     
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor( private appService:AppdataService,private loginService:LoginserviceService,public router: Router,private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,private productFindService: NgbModal,private toastr: ToastrService,private datePipe: DatePipe) {
      this.fnServiceChanges();

      this.dateCustomClasses = [
        { date: new Date(), classes: ['bg-warning'] },
      ];
      this.fromdate.setDate(this.fromdate.getDate() - 15);
  }
  
  //Company Check
  fnServiceChanges(){
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }   
        
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  
  //Init
  ngOnInit() {
    try{
      if(this.loginService.fnCheckCompany()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      } 
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm(){
    this.fngetInsuranceReport();     
  }


  fnCheckPrivilage() {
    
    this.isadd=this.loginService.fnCheckUserRoleAction(this.formname,'CREATE');
    this.isedit=this.loginService.fnCheckUserRoleAction(this.formname,'ALTER');
    this.isdelete=this.loginService.fnCheckUserRoleAction(this.formname,'DELETE');
    this.isview=this.loginService.fnCheckUserRoleAction(this.formname,'VIEW');
    this.isprint=this.loginService.fnCheckUserRoleAction(this.formname,'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
    
    
  }

  fnUserFailedForm(){
    this.isprivilage=true;
  }
 
  fnActionExportClick()  {
      const params = {
        columnGroups: true,
        allColumns: true,
        fileName: 'Insurancelist',
        //columnSeparator: document.querySelector("#columnSeparator").value
      };
      //this.gridApi.exportDataAsCsv(params);
  }
  fnActionFilterClick() {  

    this.filterbar.filterstatus = this.filterstatus;
    
    this.isfilter = !this.isfilter;
  }
  fnActionRefreshClick() { 
    this.fngetInsuranceReport()
  }
  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetInsuranceReport();
     
  }

  fnCurrentRouteChange() { 
    var queryParams = {};
    

    if (this.filterstatus != '') {     
      queryParams['status'] = this.filterstatus;
    }   

     this.router.navigate(
      [], 
      {
        relativeTo: this.route,
        queryParams: queryParams, 
      
      });
  }
  
  fnRemoveFilter(type) {
    
    if(type==='INACTIVE'){
      this.filterstatus="";
      this.fngetInsuranceReport();     
    }  
    else{
      this.filterstatus="";
      this.fngetInsuranceReport();    
    }
  }

  //Get
  fngetInsuranceReport() {
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();     
      var data = {
          'insuranceid':0,
          'companyid': this.loginService.fnGetCompanyId(),
          'filterstatus':this.filterstatus     ,                                                                      
          'fromdate': this.fnFormatDatetime(this.fromdate),
          'todate': this.fnFormatDatetime(this.todate),
      }
      this.appService.getInsuranceReport(data)
      .subscribe(
          (res)=>{                  
            if(res.json().status===200){
              this.fnHideProgress();                   

                this.insuranceColl=res.json().result; 
                this.fnSetTable(); 
                this.fnCurrentRouteChange();                     
    
            }else {
              this.fnHideProgress();                   

                this.loginService.fnAPIError(res.json())
            }             
          },
          (err)=>{ 
            this.fnHideProgress();                   
         
              this.toastr.error('Error', err);
      })
  }



  fnCloseForm(){
    try{
      this.router.navigate(['/Reports']);
    }catch(ex){
       this.fnShowErrorMsg(ex);
    }
    }



  fnSetTable() {
   
  }

  public fnSearchDatatable(value){    
   // this.gridApi.setQuickFilter(value);
  }

  private fnFocusTableRow(index,status){
    if(index>-1){
      if(status==='IN'){          
        this.insuranceColl[index].hoverfocus="IN"
      }
      else{
        this.insuranceColl[index].hoverfocus=""
      }                
    }    
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.insuranceColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}

  private  fnShowErrorMsg(ex){
    this.toastr.warning('Internal Error', ex);       
  }








}
